import {Injectable} from '@angular/core';
import {Question} from '../model/question';
import {Observable} from 'rxjs/Observable';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Id} from '../model/id';
import {Answer} from '../model/answer';
import {ReportData} from "../model/report-data";
import {QuestionnaireListItem} from "../model/questionnaire-list-item";
import {QuestionnaireShort} from '../model/questionnaire-short';

@Injectable()
export class QuestionnaireService {

  constructor(private httpClient: HttpClient) {
  }

  getQuestions(questionnaireId: string): Observable<Question[]> {
    return this.httpClient.get<Question[]>('/api/questionnaire/draft/' + questionnaireId +
      '/question');
  }

  getDrafts(): Observable<QuestionnaireListItem[]> {
    return this.httpClient.get<QuestionnaireListItem[]>('/api/questionnaire/draft');
  }

  getQuestionnaire(questionnaireId: string): Observable<QuestionnaireShort> {
    return this.httpClient.get<QuestionnaireShort>('/api/questionnaire/draft/' +
      questionnaireId);
  }

  getVersions(): Observable<QuestionnaireListItem[]> {
    return this.httpClient.get<QuestionnaireListItem[]>('/api/questionnaire/version');
  }

  addQuestionnaire(title: string, description: string): Observable<Id> {
    let hp = new HttpParams().set('title', title).set('description', description);
    return this.httpClient.post<Id>('/api/questionnaire/draft', hp);
  }

  updateQuestionnaire(questionnaire: QuestionnaireShort): Observable<Id> {
    let hp = new HttpParams().set('title', questionnaire.title).set('description', questionnaire.description);
    return this.httpClient.put<Id>('/api/questionnaire/draft/' + questionnaire.id,
      hp);
  }

  deleteQuestionnaire(questionnaire: QuestionnaireListItem): Observable<any> {
    return this.httpClient.delete('/api/questionnaire/draft/' + questionnaire.id,
      {responseType: 'text'});
  }

  deleteVersion(version: QuestionnaireListItem): Observable<any> {
    return this.httpClient.delete('/api/questionnaire/version/' + version.id,
      {responseType: 'text'});
  }

  commitQuestionnaire(questionnaire: QuestionnaireListItem): Observable<Id> {
    return this.httpClient.post<Id>(
      '/api/questionnaire/draft/' + questionnaire.id, null);
  }

  addQuestion(text: string, questionnaireId: string, answer: Answer): Observable<Id> {
    let hp = new HttpParams().set('text', text);
    let hh = new HttpHeaders({'Content-Type': 'application/json'});
    return this.httpClient.post<Id>('/api/questionnaire/draft/' +
      questionnaireId + '/question', answer, {params: hp, headers: hh});
  }

  updateQuestion(question: Question): Observable<any> {
    let hp = new HttpParams().set('text', question.text);
    let hh = new HttpHeaders({'Content-Type': 'application/json'});
    return this.httpClient.put('/api/question/' + question.id, question
      .answer, {params: hp, headers: hh});
  }

  deleteQuestion(question: Question): Observable<any> {
    return this.httpClient.delete('/api/question/' + question.id);
  }

  move(id: string, onPlaceOf: string): Observable<any> {
    let hp = new HttpParams().set('on_place_of', onPlaceOf);
    return this.httpClient.post('/api/question/' + id, hp);
  }

  draftFromVersion(questionnaire: QuestionnaireListItem): Observable<Id> {
    return this.httpClient.post<Id>(
      '/api/questionnaire/version/' + questionnaire.id + "/draft", null);
  }

  buildReport(questionnaireId: string, reportPeriod: number, reportRange: number): Promise<ReportData> {
    let params: any = {report_period: reportPeriod, report_range: reportRange};
    return this.httpClient
      .get<ReportData>(`/api/questionnaire/${questionnaireId}/report`, {params: params})
      .toPromise();
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/service/questionnaire.service.ts